import axios from "axios";
import { URL, METHOD } from "src/config";

const axiosClient = axios.create({
  headers: {
    "content-type": "application/json",
  },
});

axiosClient.interceptors.request.use(async (config) => {
  return config;
});

axiosClient.interceptors.response.use((response) => {
  if (response && response.data) {
    return response.data;
  }

  return response;
});

export const createRequest = (requestPayload) => {
  let request = null;
  let config = {};

  let endpoint = URL.api + requestPayload.endpoint;
  if (requestPayload.hasOwnProperty("host")) {
    endpoint = requestPayload.host + requestPayload.endpoint;
  }

  if (requestPayload.hasOwnProperty("crossDomain")) {
    axiosClient.defaults.withCredentials = true;
  }

  if (requestPayload.hasOwnProperty("headers")) {
    config = {
      headers: requestPayload.headers,
    };
  }

  switch (requestPayload.method) {
    case METHOD.GET:
      let payload: any = {
        params: requestPayload.payload,
        ...config,
      };

      request = axiosClient.get(endpoint, payload);

      break;
    case METHOD.POST:
      request = axiosClient.post(endpoint, requestPayload.payload, config);

      break;
    case METHOD.PUT:
      request = axiosClient.put(endpoint, requestPayload.payload, config);

      break;
    default:
      request = axiosClient.get(endpoint, {
        params: requestPayload.payload,
      });

      break;
  }

  return request
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      // console.log('== REQUEST ==');
      // console.log(requestPayload);
    });
};
